module.exports = __webpack_public_path__ + "resource/img/image013.e6d355a9.png";